class ScrollToTop4i {
    constructor() {
        this.scrollBtns = [];
		this.logoLink = null;
		this.scrollThreshold = 300;
		this.scrollThrottleTimeout = null;
    }

    init = () => {
        this.scrollBtns = Array.from(document.getElementsByClassName('back-to-top'));
		this.logoLink = this.getHeaderLink();

		if (!this.scrollBtns.length) return;

		this.bindScrollButton();
		this.initiateScroll(); // Check initial state
    };

    bindScrollButton = () => {
		window.addEventListener("scroll", this.throttleScroll);
        this.scrollBtns.forEach(button => {
			button.setAttribute("aria-label", "Scroll to top"); //todo?
			button.addEventListener("click", this.goToTop);
		});
    };

    goToTop = (e) =>{
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });

        if (this.logoLink) {
            // Focus on the logo link after a short delay
            setTimeout(() => this.logoLink.focus(), 500);
        }
    };

    initiateScroll = () => {
		if (window.pageYOffset > this.scrollThreshold) {
			this.showScrollButton();
		} else {
			this.hideScrollButton();
		}
	};

	showScrollButton = () => {
		this.scrollBtns.forEach(button => {
			button.classList.remove('hide');
			button.style.opacity = "1";
			button.style.pointerEvents = "auto";
		});
	};
    
	hideScrollButton() {
		this.scrollBtns.forEach(button => {
			button.style.opacity = "0";
			button.style.pointerEvents = "none";

			setTimeout(() => {
				button.classList.add('hide');
			}, 200);
		});
	}

    throttleScroll = () => {
		if (this.scrollThrottleTimeout) return;

		this.scrollThrottleTimeout = setTimeout(() => {
			this.initiateScroll();
			this.scrollThrottleTimeout = null;
		}, 100); // Adjust this delay if needed
	};

	getHeaderLink() {
		return (
			document.querySelector(".HeaderLogo a") ||
			document.querySelector(".logo2017 a") ||
			null
		);
	}
}

export default new ScrollToTop4i();